import i18n from "../../../utils/i18n.js";
import RegistrationContactPage from "../../searchFlowVersionB/components/registrationContactPage/RegistrationContactPage.jsx";

const KftRegContactPage = (props) => (
  <RegistrationContactPage
    recommendationTitle={i18n.t("searchflow.kftregofferrecommendation")}
    priceLabel={i18n.t("searchflow.kftregofferpricelabel")}
    priceAmount={i18n.t("searchflow.kftregofferpriceamount")}
    chipFields={["companytype", "taxform", "industry", "activity", "foreigntrade"]}
    callbacksource="kftregrequest"
    createAspRequest={props.createAspRequest}
    onRequestError={props.onRequestError}
    handleNext={props.handleNext}
  />
);

export default KftRegContactPage;
